<template>
  <div class="accountServices">
    <!-- <div class="select-service">
      <span class="serviceName">代理记账</span>
      <span class="select-arrow"></span>
    </div> -->
    <!-- <div class="companyName">{{serviceInfo ? serviceInfo.companyName : ''}}</div> -->
    <!-- <div class="service-period">
      <div class="title">服务期间</div>
      <div class="period" v-if="startTime || endTime ">{{startTime ? startTime : '未设置'}}-{{endTime ? endTime : '未设置'}}</div>
      <div class="period" v-else>未设置</div>
    </div> -->

    <div class="service-detail" v-if="serviceInfo">
      <van-row class="detail-cell">
        <van-col span="3" class="cell-icon">
          <i class="iconfont icon-service_to fs20"></i>
        </van-col>
        <van-col span="6" class="title">
          服务期间
        </van-col>
        <van-col span="14" class="content step-gray pr15">
          <div class="period" v-if="startTime || endTime ">{{startTime ? startTime : '未设置'}}-{{endTime ? endTime : '未设置'}}</div>
          <div class="period" v-else>未设置</div>
        </van-col>
      </van-row>
      <van-row class="detail-cell" @click.native="goTaxDetail()">
        <van-col span="3" class="cell-icon">
          <i class="iconfont icon-service_time fs20"></i>
        </van-col>
        <van-col span="13" class="title">
          报税至
        </van-col>
        <van-col span="7" class="content pr15" :class="serviceInfo.taxDate ? 'uderway-color' : 'step-gray'">
          <div :class="serviceInfo.taxDate ? '' : 'pr15'">
            {{serviceInfo.taxDate ? serviceInfo.taxDate : '无'}}
            <van-icon v-if="serviceInfo.taxDate" class="rightArrow" name="arrow" />
          </div>
        </van-col>
      </van-row>
      <van-row class="detail-cell">
        <van-col span="3" class="cell-icon">
          <i class="iconfont iconjizhangzhi fs20" style="font-size: 0.23rem !important;"></i>
        </van-col>
        <van-col span="13" class="title">
          记账至
        </van-col>
        <van-col span="7" class="content step-gray">
          <div class="right-text">
            {{serviceInfo.accountDate ? serviceInfo.accountDate : '无'}}
          </div>
        </van-col>
      </van-row>
      <van-row class="detail-cell last-cell">
        <van-col span="3" class="cell-icon">
          <i class="iconfont icon-confirm_order fs20" style="color:#FF3400;"></i>
        </van-col>
        <van-col span="13" class="title">
          凭证
        </van-col>
        <van-col @click.native="linkToVoucher" span="7" class="content" :class="serviceInfo.vcCount > 0 ? 'uderway-color' : 'step-gray'">
          <div class="pr15">
            {{serviceInfo.vcCount}}张
            <van-icon v-if="serviceInfo.vcCount>0" class="rightArrow" name="arrow" />
          </div>
        </van-col>
      </van-row>
    </div>
    <div class="evaluate-row" v-if="!Object.keys(fromAcctCustomerInfo).length">
      <van-button plain round type="warning" @click="showEvaluateDialog">{{!!scoreId ? '查看评价' : '评价服务'}}</van-button>
    </div>
    <!-- <div class="manage" @click="callManage()" v-if="serviceInfo && serviceInfo.phone">
      <span class="text">联系客户经理</span>
      <i  class="iconfont icon-phone phone" />
    </div> -->
    <call-phone @telShowFalse="onTelCancel" :contactPhone="serviceInfo ? serviceInfo.phone : ''" :telShow="telShow" />
    <van-popup v-model="evaluateShow">
      <div class="evaluate-popo">
        <van-row>
          <van-col class="evaluate-title" :span="24">
            {{!!scoreId ? '查看评价' : '评价服务'}}
          </van-col>
        </van-row>
        <van-row class="evaluate-item">
          <van-col class="evaluate-label" :span="6">
            总体
          </van-col>
          <van-col class="evaluate-score" :span="14">
            <van-rate v-model="totalScore" allow-half :size="20" :readonly="!!scoreId" color="#ffd21e" void-icon="star" void-color="#eee" />
          </van-col>
          <van-col class="evaluate-number" :span="4">
            {{totalScore}}
          </van-col>
        </van-row>
        <van-row class="evaluate-item">
          <van-col class="evaluate-label" :span="6">
            服务效率
          </van-col>
          <van-col class="evaluate-score" :span="14">
            <van-rate v-model="efficiencyScore" allow-half :size="20" :readonly="!!scoreId" color="#ffd21e" void-icon="star" void-color="#eee" />
          </van-col>
          <van-col class="evaluate-number" :span="4">
            {{efficiencyScore}}
          </van-col>
        </van-row>
        <van-row class="evaluate-item">
          <van-col class="evaluate-label" :span="6">
            服务质量
          </van-col>
          <van-col class="evaluate-score" :span="14">
            <van-rate v-model="qualityScore" allow-half :size="20" :readonly="!!scoreId" color="#ffd21e" void-icon="star" void-color="#eee" />
          </van-col>
          <van-col class="evaluate-number" :span="4">
            {{qualityScore}}
          </van-col>
        </van-row>
        <van-row class="evaluate-item">
          <van-col class="evaluate-label" :span="6">
            服务态度
          </van-col>
          <van-col class="evaluate-score" :span="14">
            <van-rate v-model="attitudeScore" allow-half :size="20" :readonly="!!scoreId" color="#ffd21e" void-icon="star" void-color="#eee" />
          </van-col>
          <van-col class="evaluate-number" :span="4">
            {{attitudeScore}}
          </van-col>
        </van-row>
        <div class="evaluate-action-row">
          <van-button plain round size="small" :class="!scoreId? 'close-btn' : ''" @click="closeEvaluateDialog">关闭</van-button>
          <van-button v-if="!scoreId" plain round type="warning" size="small" @click="confirmEvaluateDialog">提交评价</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import Vue from "vue";
  import {
    Tabbar,
    TabbarItem,
    Row,
    Col,
    Icon,
    ActionSheet,
    Button,
    Rate,
    Popup,
    Toast
  } from "vant";
  import moment from 'moment'
  import callPhone from "@/components/CallPhone.vue";

  Vue.use(Tabbar).use(TabbarItem).use(Row).use(Col).use(Icon).use(ActionSheet).use(Button).use(Rate).use(Popup).use(Toast)

  export default {
    name: "accountServices",
    components: {
      callPhone
    },
    data() {
      return {
        serviceInfo: null,
        startTime: '',
        endTime: '',
        telShow: false,
        fromAcctCustomerInfo: this.$store.state.fromAcctCustomerInfo,
        scoreId: this.$route.query.scoreId,
        customerId: this.$route.query.customerId,
        totalScore: 0,
        efficiencyScore: 0,
        qualityScore: 0,
        attitudeScore: 0,
        evaluateShow: false,
      }
    },
    mounted() {
      this.$root.$emit('log-record', "50010059");
      if (!this.serviceInfo) {
        let url = Object.keys(this.fromAcctCustomerInfo).length > 0 ? ("/fc/small/program/dzfwlist?dbId=" + this.fromAcctCustomerInfo.databaseId + '&companyId=' + this.fromAcctCustomerInfo.companyId) : ("/fc/small/program/dzfwlist")
        this.$http.get(url).then((res) => {
          // console.log(JSON.stringify(res));
          if (res.data.code == 200) {
            let result = res.data.data
            if (result.businessList.length > 0) {
              this.serviceInfo = result.businessList[0]
              this.endTime = this.serviceInfo.endTime == 0 ? '' : this.formatServiceTime(this.serviceInfo.endTime.toString())
              this.startTime = this.serviceInfo.startTime == 0 ? '' : this.formatServiceTime(this.serviceInfo.startTime.toString())
            }
          }
        }).catch(error => {
          console.log(error, "error");
        });
      } else {
        this.serviceInfo = this.$route.query.accountInfo
        this.endTime = this.serviceInfo.endTime == 0 ? '' : this.formatServiceTime(this.serviceInfo.endTime.toString())
        this.startTime = this.serviceInfo.startTime == 0 ? '' : this.formatServiceTime(this.serviceInfo.startTime.toString())
      }
    },
    methods: {
      linkToVoucher() {
        this.$router.push({
          name: "voucherList"
        });
      },
      serviceOnSelect(item) {
        this.showServiceList = false
        console.log(item)
        this.selectService = item
      },
      goTaxDetail() {
        this.$root.$emit('log-record', "50010060");
        if (this.serviceInfo.taxDate) {
          let date = moment(this.serviceInfo.taxDate).format('YYYYM')
          let param = {
            year: date.substr(0, 4),
            month: date.substr(4, date.length - 4)
          }
          this.$router.push({
            name: 'taxDetail',
            params: param
          })
        }
      },
      callManage() {
        this.$root.$emit('log-record', "50010062");
        this.telShow = true
      },
      formatServiceTime(time) {
        return time.substr(0, 4) + '.' + time.substr(4, 2)
      },
      onTelCancel() {
        this.$root.$emit('log-record', "50010064");
        this.telShow = false;
      },
      getScore() {
        let url = Object.keys(this.fromAcctCustomerInfo).length > 0 ? ('/fc/small/program/service/score?&dbId=' + this.fromAcctCustomerInfo.databaseId + '&companyId=' + this.fromAcctCustomerInfo.companyId + '&scoreId=' + this.scoreId) : ('/fc/small/program/service/score?scoreId=' + this.scoreId)
        this.$http.get(url).then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            this.totalScore = data.tscore
            this.efficiencyScore = data.xlscore
            this.qualityScore = data.zlscore
            this.attitudeScore = data.tdscore
          } else if (res.data.code == 500) {
            console.log('000')
          } else {
            Toast(res.data.msg);
          }
        })
      },
      showEvaluateDialog() {
        if (!this.scoreId) {
          this.totalScore = 0
          this.efficiencyScore = 0
          this.qualityScore = 0
          this.attitudeScore = 0
        }
        if (this.scoreId) {
          this.getScore()
        }
        this.evaluateShow = true
      },
      closeEvaluateDialog() {
        this.evaluateShow = false
      },
      confirmEvaluateDialog() {
        let url = Object.keys(this.fromAcctCustomerInfo).length > 0 ? ('/fc/small/program/service/score?&dbId=' + this.fromAcctCustomerInfo.databaseId + '&companyId=' + this.fromAcctCustomerInfo.companyId) : ('/fc/small/program/service/score')
        let params = {
          customerId: this.customerId,
          acctOrderServiceId: 0,
          tscore: this.totalScore,
          xlscore: this.efficiencyScore,
          zlscore: this.qualityScore,
          tdscore: this.attitudeScore
        }

        this.$http.post(url, params).then(res => {
          if (res.data.code == 200) {
             Toast('评价成功')
             this.evaluateShow = false
             this.scoreId = res.data.data
          } else {
            Toast(res.data.msg);
          }
        })
      },
    }
  };
</script>

<style lang="stylus" scoped>
  .accountServices {
    border-top: 0.1rem solid #f0f2f2;
  }

  .select-service {
    background-color: #fff;
    width: 100%;
    height: 0.4rem;
    line-height: 0.4rem;
    color: #2C3E50;
    font-size: 0.16rem;
    font-weight: 500;
    text-align: center;
  }

  .select-arrow {
    position: relative;
    width: 0;
    height: 0;
    border-left: 0.05rem solid transparent;
    border-right: 0.05rem solid transparent;
    border-top: 0.05rem solid black;
    margin-left: 0.1rem;
    top: 0.1rem;
  }

  .companyName {
    background-color: #fff;
    height: 0.28rem;
    line-height: 0.28rem;
    font-size: 0.12rem;
    color: #8896A4;
    text-align: center;
  }

  .service-period {
    background-color: #fff;
    width: 100%;
    height: 0.46rem;
    margin-top: 0.1rem;
    padding: 0.1rem 0px;
    text-align: center;

    .title {
      font-size: 0.12rem;
      font-weight: 400;
      color: #8896A4;
      line-height: 0.2rem;
    }

    .period {
      font-size: 0.16rem;
      font-weight: 500;
      color: #2C3E50;
      line-height: 0.26rem;
    }
  }

  .service-detail {
    background: #ffffff;
    border-top: 1px solid #f0f2f2;
    height: 2.26rem;

    .detail-cell {
      height: 0.56rem;
      line-height: 0.56rem;

      img {
        position: relative;
        width: 0.22rem;
        top: 0.06rem;
      }

      .cell-icon {
        text-align: center;
        line-height: 0.52rem;
      }

      .title {
        font-size: 0.16rem;
        border-bottom: 1px solid #E6EBF0;
      }

      .content {
        margin-right: 0.1rem;
        line-height: 0.56rem;
        text-align: right;
        border-bottom: 1px solid #E6EBF0;
      }

      .rightArrow {
        position: relative;
        top: 0.02rem;
      }

      .right-text {
        padding-right: 0.16rem;
      }
    }

    .last-cell {
      .title {
        border-bottom: none;
      }

      .content {
        border-bottom: none;
      }
    }
  }

  .manage {
    background: #fff;
    height: 0.48rem;
    text-align: center;
    line-height: 0.48rem;
    margin: 0 auto;
    margin-top: 0.1rem;

    .text {
      color: #8896A4;
      font-size: 0.16rem;
    }
  }

  .step-bg {
    position: relative;
    background: #f0f2f2;
    padding-top: 0.12rem;
    padding-bottom: 50px;
  }

  .steps {
    width: 3.51rem;
    height: 0.56rem;
    background: #ffffff;
    border-radius: 6px;
    margin-left: 0.12rem;
    margin-bottom: 0.12rem;

    .step-icon {
      padding: 0.2rem 0;
      text-align: center;

      img {
        width: 0.17rem;
        height: 0.17rem;
      }

      .step-point {
        width: 0.06rem;
        height: 0.06rem;
        background: #8896A4;
        border-radius: 0.03rem;
        margin: 0 auto;
        margin-top: 0.05rem;
      }
    }

    .step-name {
      // line-height: 0.56rem;
      padding: 0.1rem 0;

      .name {
        font-size: 0.16rem;
        font-weight: 300;
      }

      .status {
        font-size: 0.12rem;
        color: #8896A4;
      }
    }

    .step-date {
      line-height: 0.56rem;

      .text {
        text-align: right;
        padding-right: 0.12rem;
      }
    }

    .step-line {
      position: relative;
      width: 1px;
      height: 0.12rem;
      background: #D8DFE6;
      top: 0.56rem;
      left: 0.2rem;
    }
  }

  .call-manage {
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 0.16rem;
    color: #516374;
  }

  .uderway-color {
    color: #1FADF6;
  }

  .step-gray {
    color: #8896A4;
  }

  .lh56 {
    line-height: 0.56rem;
  }

  .lh36 {
    line-height: 0.36rem;
  }

  .pr15 {
    padding-right: 0.16rem;
  }
</style>

<style lang="stylus">
  .accountServices .phone {
    font-size: 0.16rem;
    color: #8896A4;
    margin-left: 0.08rem;
  }

  .icon-service_to {
    color: #3FD38E;
  }

  .icon-service_time {
    color: #00D6F0;
  }

  .iconjizhangzhi {
    color: #FF8C3E;
  }

  .evaluate-popo {
    width: 3rem;
    padding: 0.16rem;
  }

  .evaluate-title {
    padding: 0.04rem 0;
    font-size: 0.16rem;
    border-bottom: 0.01rem solid #e0e0e0;
    margin-bottom: 0.16rem;
  }

  .evaluate-row {
    text-align: center;
    margin-top: 0.4rem;
  }

  .evaluate-item {
    height: 0.2rem;
    line-height: 0.2rem;
    padding: 0.04rem 0;
  }

  .evaluate-label {
    text-align: right;
    padding-right: 0.16rem;
  }

  .evaluate-action-row {
    text-align: center;
    margin-top: 0.16rem;
  }

  .close-btn {
    margin-right: 0.16rem;
  }

  .evaluate-number {
    color: #ff976a;
  }
</style>